import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Do my sales reps need to learn a new tool?',
    answer: 'No. Kinase runs in the background. Reps keep using Zoom as usual. After each call, the recording is processed and synced to HubSpot. The only optional interaction is a quick Slack approval if your admin enables the review step.'
  }, {
    question: 'Is Kinase ready for production use?',
    answer: 'Kinase is in early access. The core pipeline (Zoom ingestion, qualification extraction, HubSpot sync) is live and stable. We are actively building with our first customers and shipping improvements weekly. Early access is free, and we offer direct support from the founding team.'
  }, {
    question: 'What happens during back-to-back calls?',
    answer: 'Each recording is processed independently and in parallel. Even if a rep has five calls in a row with no breaks, every recording is analyzed, summarized, and synced.'
  }, {
    question: 'How does the HubSpot integration work?',
    answer: 'Kinase connects to your HubSpot instance via OAuth. Once a call is processed, you can review the extracted data (BANT, MEDDICC, etc.) and push it directly to the corresponding Deal, Contact, and Company records with a single click. We never overwrite existing data without your permission.'
  }, {
    question: 'Is my call data secure and private?',
    answer: 'Yes. Recordings and transcripts are encrypted at rest (AES-256) and in transit. We do not use your data to train our models.'
  }, {
    question: 'Which video conferencing platforms do you support?',
    answer: 'We currently support Zoom recordings natively. Kinase ingests call recordings automatically. No calendar connection or bot joining required. Support for additional platforms is on the roadmap.'
  }, {
    question: 'Can I customize the qualification frameworks?',
    answer: 'Yes! While we offer out-of-the-box support for BANT, MEDDICC, MEDDPICC, and SPICED, Pro and Enterprise customers can define custom extraction criteria to match their exact sales methodology and HubSpot custom properties.'
  }, {
    question: 'What happens if the AI makes a mistake?',
    answer: 'Admins can configure Kinase to require a quick Slack approval from the rep before anything is synced to HubSpot. Nothing gets written to your CRM without a human check.'
  }];
  return <section className="py-24 md:py-32 bg-white border-t border-slate-100" data-id="element-21">
      <div className="max-w-3xl mx-auto px-6 sm:px-8" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-teal-600 mb-4" data-id="element-24">
            FAQ
          </div>
          <h2 className="text-3xl md:text-4xl font-medium text-slate-900 mb-6" data-id="element-25">
            Frequently asked questions
          </h2>
          <p className="text-base text-slate-600 font-normal" data-id="element-26">
            Common questions about setup, security, and pricing.
          </p>
        </div>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden bg-slate-50/50" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-29">
                <span className="text-base font-medium text-slate-900" data-id="element-30">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-slate-400 transition-transform duration-200 flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>
              <AnimatePresence initial={false} data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-33">
                    <div className="px-6 pb-6 text-sm text-slate-600 leading-relaxed" data-id="element-34">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}